import { MasterDataSDK } from 'neko-common';
import { PingResponse } from 'public-contracts';
import { configs } from '../configs';

export default class AppInfoService {
  private sdk: MasterDataSDK;
  private interval: NodeJS.Timeout | null = null;

  constructor() {
    this.sdk = new MasterDataSDK(configs.apiRoot);
  }

  async getAppInfo(): Promise<PingResponse> {
    return await this.sdk.ping.ping(configs.clientId);
  }

  async saveAppInfo(): Promise<void> {
    const res = await this.getAppInfo();
    localStorage.setItem('appInfo', JSON.stringify(res));
  }

  getAppInfoFromStorage(): PingResponse | null {
    const appInfo = localStorage.getItem('appInfo');
    if (appInfo) {
      try {
        return JSON.parse(appInfo);
      } catch (error) {
        console.error('Error parsing appInfo from storage:', error);
        return null;
      }
    }
    return null;
  }

  async checkNewVersion(): Promise<boolean> {
    try {
      const appInfo = this.getAppInfoFromStorage();
      const newAppInfo = await this.getAppInfo();

      if (appInfo) {
        // Check both version and buildNumber
        const hasNewVersion =
          appInfo.version !== newAppInfo.version ||
          appInfo.buildNumber !== newAppInfo.buildNumber;

        return hasNewVersion;
      }
      // If no stored info, this is the first load - save it
      await this.saveAppInfo();
      return false;
    } catch (error) {
      console.error('Error checking for new version:', error);
      return false;
    }
  }

  async onNewVersion(callback: () => void): Promise<void> {
    // Check immediately
    if (await this.checkNewVersion()) {
      callback();
    }

    // Check every 5 minutes
    this.interval = setInterval(async () => {
      if (await this.checkNewVersion()) {
        callback();
      }
    }, 1000 * 60 * 5);
  }

  offNewVersion(): void {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  getCurrentVersion(): PingResponse | null {
    return this.getAppInfoFromStorage();
  }
}
